import { useT, useLocale } from "@/lib/i18n";
import { LocaleLink } from "./LocaleLink";
import { LangSwitcher } from "./LangSwitcher";
import { useWelcomeStore } from "@/components/welcome/welcomeStore";
import { openConsentSettings } from "@/lib/consent";


export function SiteFooter() {
  const { t } = useT();
  const locale = useLocale();
  const reopen = useWelcomeStore((s) => s.reopen);
  return (
    <footer className="relative mt-32 overflow-hidden bg-foreground text-background">
      {/* Murano rainbow stripe — sits flush above the footer like a glass band */}
      <div className="stripe-rainbow h-1 w-full" aria-hidden="true" />
      <div className="mx-auto max-w-[1500px] px-6 py-20 md:px-10">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <p className="eyebrow text-amber-glass">Farveladeland</p>
            <h2 className="mt-4 font-display text-4xl leading-[1.05] text-background md:text-5xl">
              {t("footer.tagline.line1")}
              <br />
              <em className="text-amber-glass">{t("footer.tagline.line2")}</em>
            </h2>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-background/70">
              {t("footer.about")}
            </p>
          </div>

          <div className="md:col-span-2">
            <p className="eyebrow text-amber-glass">{t("footer.wander")}</p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><LocaleLink to="/murano" className="hover:text-amber-glass">{t("footer.editMurano")}</LocaleLink></li>
              <li><LocaleLink to="/collections" className="hover:text-amber-glass">{t("footer.allCollections")}</LocaleLink></li>
              <li><LocaleLink to="/farver" className="hover:text-amber-glass">{t("header.colors")}</LocaleLink></li>
              <li><LocaleLink to="/storrelse" className="hover:text-amber-glass">{t("header.sizes")}</LocaleLink></li>
             <li><LocaleLink to="/murano/match" className="hover:text-amber-glass">{t("header.match")}</LocaleLink></li>
             
             <li><LocaleLink to="/blog" className="hover:text-amber-glass">{t("header.blog")}</LocaleLink></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="eyebrow text-amber-glass">{locale === "da" ? "Om" : "About"}</p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><LocaleLink to="/about" className="hover:text-amber-glass">{t("footer.story")}</LocaleLink></li>
              <li><LocaleLink to="/showroom" className="hover:text-amber-glass">{t("footer.showroom")}</LocaleLink></li>
              <li><LocaleLink to="/visit" className="hover:text-amber-glass">{t("footer.bookViewing")}</LocaleLink></li>
              <li><LocaleLink to="/faq" className="hover:text-amber-glass">FAQ</LocaleLink></li>
              <li><LocaleLink to="/privacy" className="hover:text-amber-glass">Privacy</LocaleLink></li>
              <li>
                <button
                  type="button"
                  onClick={openConsentSettings}
                  className="text-left hover:text-amber-glass"
                >
                  {t("cookie.settings")}
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={reopen}
                  className="text-left hover:text-amber-glass"
                >
                  {t("welcome.replay")}
                </button>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="eyebrow text-amber-glass">{t("footer.visit")}</p>
            <address className="mt-4 not-italic whitespace-pre-line text-sm leading-relaxed text-background/70">
              {t("footer.address")}
            </address>

            <div className="mt-8 flex flex-wrap items-center gap-4 text-xs uppercase tracking-[0.2em] text-background/60">
              <a href="https://www.instagram.com/farveladeland/" target="_blank" rel="noreferrer" className="hover:text-amber-glass">{t("footer.instagram")}</a>
              <a href="mailto:butik@farveladeland.com" className="hover:text-amber-glass">Mail</a>
              <span className="ml-auto"><LangSwitcher onDark /></span>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-background/15 pt-6 text-[11px] uppercase tracking-[0.2em] text-background/50 md:flex-row md:items-center">
          <span>© {new Date().getFullYear()} {t("footer.copy")}</span>
          <span>{t("footer.handblown")}</span>
        </div>
      </div>
    </footer>
  );
}
